import apiCom from '../src/libraries/apiCom';
const employer_token = 'bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9sb2NhbGhvc3Q6ODAwMFwvYXBpXC9zdGF0aWNfYXV0aCIsImlhdCI6MTYyMDY1ODA4OCwiZXhwIjo5OTAyMDg0NzA2OCwibmJmIjoxNjIwNjU4MDg4LCJqdGkiOiJTU3NBcjlGVmxTSVg4ZXhDIiwic3ViIjo0MDA4LCJwcnYiOiI4N2UwYWYxZWY5ZmQxNTgxMmZkZWM5NzE1M2ExNGUwYjA0NzU0NmFhIn0.WlEq0b4Wzpu1XeHAy1LHCApinjfh2Aq7kSfUlNnw6Ms'


class AwsUpload {
    constructor() {}

    async uploadToS3(file, filename){
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                const base64Data = reader.result.split(',')[1];

                const textEncoder = new TextEncoder();
                const dataBytes = textEncoder.encode(base64Data);
                const fileSizeInBytes = dataBytes.byteLength;
                if(fileSizeInBytes < 29000000) {
                    try {
                        const response = await new apiCom('employer', '/aws-upload').post({ file: base64Data, filename }, { Authorization: employer_token });
                        resolve(response);
                    } catch (error) {
                        reject(error);
                    }
                } else {
                    reject('File exceeds size limit');
                }
        
                reader.onerror = (error) => {
                    reject(error);
                }
            }
        })
    }
    async uploadImage(file, filename) {
        if (file.size < 20000000) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = async () => {
                    try {
                        const pdfBlob = reader.result
                        const data = { file: pdfBlob, filename: filename};
                        const response = await new apiCom('employer', '/aws-image-upload').post(data, { Authorization: employer_token });
                        resolve(response);
                    } catch (error) {
                        reject(error);
                    }
                };
    
                reader.onerror = (error) => {
                    reject(error);
                };
                reader.readAsDataURL(file);
            });
        } else {
            return 'File is large';
        }
    }
}


export default AwsUpload;
